import classNames from 'classnames'
import {useState} from 'react'
import {RenderIf} from '../RenderIf'
import {SvgIcon} from './SvgIcon'

export const RoundPlusIcon: SvgIcon = ({
  width = 24,
  height = 24,
  strokeColor = 'text-white',
  strokeWidth = 1.2,
  fillColor = '#00000000',
  classes,
  onClick,
  datacy = 'round-plus-icon',
  ariaLabel = 'Add',
}) => {
  const [isHover, setIsHover] = useState<boolean>(false)
  return (
    <svg
      aria-label={ariaLabel}
      role="button"
      data-cy={datacy}
      onClick={onClick}
      width={width}
      height={height}
      fill={fillColor}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      className={classNames(strokeColor, classes, {
        'stroke-current': !isHover,
      })}
      onMouseEnter={() => setIsHover(true)}
      onMouseLeave={() => setIsHover(false)}
    >
      <title>{ariaLabel}</title>
      <RenderIf isTrue={isHover}>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4ZM12.75 8.75003C12.75 8.33582 12.4142 8.00003 12 8.00003C11.5858 8.00003 11.25 8.33582 11.25 8.75003V11.25H8.75C8.33579 11.25 8 11.5858 8 12C8 12.4142 8.33579 12.75 8.75 12.75H11.25V15.25C11.25 15.6642 11.5858 16 12 16C12.4142 16 12.75 15.6642 12.75 15.25V12.75H15.25C15.6642 12.75 16 12.4142 16 12C16 11.5858 15.6642 11.25 15.25 11.25H12.75V8.75003Z"
          className="fill-current"
        />
      </RenderIf>
      <RenderIf isTrue={!isHover}>
        <>
          <path
            d="M4.75 12C4.75 7.99594 7.99594 4.75 12 4.75C16.0041 4.75 19.25 7.99594 19.25 12C19.25 16.0041 16.0041 19.25 12 19.25C7.99594 19.25 4.75 16.0041 4.75 12Z"
            strokeWidth={strokeWidth}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M12 8.75V15.25"
            strokeWidth={strokeWidth}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M15.25 12L8.75 12"
            strokeWidth={strokeWidth}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      </RenderIf>
    </svg>
  )
}

export const PlusIcon: SvgIcon = ({
  width = 24,
  height = 24,
  strokeColor = 'text-gray-1600',
  strokeWidth = 1.2,
  classes,
  onClick,
  datacy = 'plus-icon',
}) => {
  return (
    <svg
      data-cy={datacy}
      onClick={onClick}
      width={width}
      height={height}
      xmlns="http://www.w3.org/2000/svg"
      viewBox={`0 0 ${width} ${height}`}
      className={classNames(strokeColor, classes, 'stroke-current')}
    >
      <path
        d="M8 3.83362V12.167"
        className="stroke-current"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.1663 8.00024H3.83301"
        className="stroke-current"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export const PlusIconCorrect: SvgIcon = ({
  width = 24,
  height = 24,
  strokeColor = 'text-gray-1600',
  strokeWidth = 1.2,
  classes,
  onClick,
  datacy = 'plus-icon',
}) => {
  return (
    <svg
      data-cy={datacy}
      onClick={onClick}
      width={width}
      height={height}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      className={classNames(strokeColor, classes, 'stroke-current')}
    >
      <path
        d="M12 5V19"
        className="stroke-current"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5 12H19"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
